import React from 'react'

function ViewRolesDataByID({viewRolesdata, setViewRolesData}) {
  return (
  <div className="fixed inset-0 z-50 flex items-center justify-center">
    
    {/* Overlay */}
    <div
      onClick={() => setViewRolesData(null)}
      className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity"
    />

    {/* Modal Card */}
    <div className="relative bg-white w-[95%] max-w-2xl rounded-2xl shadow-2xl p-8 animate-[fadeIn_.25s_ease-out]">

      {/* Header */}
      <div className="flex justify-between items-center border-b pb-4 mb-6">
        <h2 className="text-2xl font-semibold text-gray-800">
          Role Details
        </h2>

        <button
          onClick={() => setViewRolesData(null)}
          className="text-gray-400 hover:text-red-500 transition text-xl"
        >
          ✕
        </button>
      </div>

      {/* Content */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">

        <div>
          <p className="text-gray-500">Role Name</p>
          <p className="font-medium text-gray-800">
            {viewRolesdata?.roleName}
          </p>
        </div>

        <div>
          <p className="text-gray-500">Prefix</p>
          <p className="font-medium text-gray-800">
            {viewRolesdata?.prefix}
          </p>
        </div>

        <div>
          <p className="text-gray-500">Description</p>
          <p className="font-medium text-gray-800">
            {viewRolesdata?.roleDescription || "—"}
          </p>
        </div>

        <div>
          <p className="text-gray-500">Status</p>
          <span
            className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
              viewRolesdata?.isActive === 1
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-600"
            }`}
          >
            {viewRolesdata?.isActive === 1 ? "Active" : "Inactive"}
          </span>
        </div>

        <div>
          <p className="text-gray-500">Created At</p>
          <p className="font-medium text-gray-800">
            {new Date(viewRolesdata?.created_at).toLocaleString()}
          </p>
        </div>

        <div>
          <p className="text-gray-500">Updated At</p>
          <p className="font-medium text-gray-800">
            {new Date(viewRolesdata?.updated_at).toLocaleString()}
          </p>
        </div>

        {viewRolesdata?.deactivatedAt && (
          <div>
            <p className="text-gray-500">Deactivated At</p>
            <p className="font-medium text-gray-800">
              {new Date(viewRolesdata?.deactivatedAt).toLocaleString()}
            </p>
          </div>
        )}

        <div>
          <p className="text-gray-500">Role ID</p>
          <p className="font-mono text-xs text-gray-600 break-all">
            {viewRolesdata?.id}
          </p>
        </div>

      </div>

      {/* Footer */}
      <div className="mt-8 text-right">
        <button
          onClick={() => setViewRolesData(null)}
          className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
        >
          Close
        </button>
      </div>
    </div>
  </div>
  )}
  
export default ViewRolesDataByID